export default "__VITE_ASSET__BFn1fK8I__"